import { ReactElement } from 'react'
import { useSnowLoadAssignment } from '@scene'
import ManualLoadIcon from '../ManualLoadIcon'
import useManualLoadAssignment from '../hooks/useManualLoadAssignment'

interface Props {
  slab: ShapeObject
  color?: string
  opacity?: number
}

const ManualLoadIndicator = ({ slab, color, opacity }: Props): ReactElement => {
  const { hasSnowLoad } = useSnowLoadAssignment({ slab })
  const { hasManualLoad, pointForIcon, rotation } = useManualLoadAssignment({
    slab,
    offsetX: hasSnowLoad ? 0.9 : 0.6, // Position after snow load icon
  })

  return (
    <ManualLoadIcon
      hasManualLoad={hasManualLoad}
      pointForIcon={pointForIcon}
      color={color}
      rotation={rotation}
      opacity={opacity}
    />
  )
}

export default ManualLoadIndicator
